import tooltipComponent from './tooltip.component';

const ertTooltipModule = angular.module('app.common.ertTooltip', [])
	.component('ertTooltip', tooltipComponent)
	.name;

export default ertTooltipModule;
